
import React from "react";
import { Link } from "react-router-dom";
import { Badge } from "@/components/ui/badge";
import { MapPin, Star } from "lucide-react";
import { Business } from "@/types";

interface BusinessHeaderProps {
  business: Business;
}

const BusinessHeader: React.FC<BusinessHeaderProps> = ({ business }) => {
  return (
    <div className="relative h-80 w-full overflow-hidden rounded-lg mb-8">
      <img
        src={business.imageUrl}
        alt={business.name}
        className="w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent">
        <div className="absolute bottom-0 left-0 p-6">
          <Badge className="mb-2 bg-eco-500">{business.category}</Badge>
          <h1 className="text-4xl font-bold text-white mb-2">{business.name}</h1>
          <div className="flex items-center text-white">
            <MapPin className="h-5 w-5 mr-2" />
            <span>
              {business.address}, {business.city}, {business.state}
            </span>
          </div>
        </div>
      </div>
      <div className="absolute top-4 right-4 bg-eco-500 text-white rounded-full px-3 py-1 flex items-center">
        <Star className="h-4 w-4 mr-1 fill-white" />
        <span className="font-semibold">{business.rating}</span>
      </div>
    </div>
  );
};

export default BusinessHeader;
